const _headersWM: WeakMap<HeadersBuilder, Map<string, string>> = new WeakMap();
const _headers = (o: HeadersBuilder) => _headersWM.get(o)!;

function normalizeName(name: string) {
    if (typeof name !== "string")
        name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name))
        throw new TypeError("Invalid character in header field name");
    return name.toLowerCase();
}

export class HeadersBuilder {
    constructor(...headers: ({ [name: string]: any } | Headers | HeadersBuilder | undefined)[]) {
        _headersWM.set(this, new Map());
        this.setHeaders(...headers);
    }

    /**
     * Přidá nový záznam ho objektu hlaviček
     * @param name jméno hlavičky
     * @param value hodnota
     * @param isDefaultValue funkce, která detekuje defaultní hodnotu která se nebude vkládat
     */
    public set(name: string, value: any, isDefaultValue?: (value: any) => boolean): void {
        const _h = _headers(this);
        if ((value != undefined) && (!isDefaultValue || !isDefaultValue(value)))
            _h.set(normalizeName(name), typeof value === "string" ? value : String(value));
    }

    /**
     * Spojí několik struktur s definicí hlaviček do jedné struktury
     * @param headers Definice hlaviček
     */
    public setHeaders(...headers: ({ [name: string]: string } | Headers | HeadersBuilder | undefined)[]): void {
        for (const item of headers)
            if (item)
                for (const [name, value] of (typeof (item as any)[Symbol.iterator] === "function" ? item as any : Object.entries(item)))
                    this.set(name, value);
    }

    public delete(name: string): void {
        _headers(this).delete(name);
    }

    public get(name: string): string | undefined {
        return _headers(this).get(name);
    }

    public has(name: string): boolean {
        return _headers(this).has(name);
    }

    public entries(): IterableIterator<[string, string]> {
        return _headers(this).entries();
    }

    public [Symbol.iterator](): IterableIterator<[string, string]> {
        return this.entries();
    }

    public values(): IterableIterator<string> {
        return _headers(this).values();
    }

    public keys(): IterableIterator<string> {
        return _headers(this).keys();
    }
}

/*
V Safari (< 11.1) neprojde tento testcase
Safari iteruje vstupni objekty jen přes Object.entries
Chrome, FireFox, Sfari 11.1+     OK

let h1 = new TescoSW.HeadersBuilder({ "Accept": "application/vnd.tescosw.ow-datarows+json" });
let h2 = new Headers(h1);
h2.append("X-1233",15);
for (var pair of h2) {
        logger.log(pair[0]+ ': '+ pair[1]);
}
*/
